import { BookingData, BookingTool, Step } from "../../AppDataProvider/AppDataProvider";
import { ResourceAllocationType, ResourceSelectionMode } from "../../GeneratedGraphQL";
type GetFirstStepOpts = {
  bookingData: BookingData;
  bookingTool: BookingTool;
};

/**
 * Get the first step that the booking tools should
 * display based on the bookingTool configuration.
 */
export const getFirstStep = (options: GetFirstStepOpts): Step => {
  const {
    forceServiceSelection,
    services,
    forceOrganisationSelection,
    organisations,
    resourceSelectionMode
  } = options.bookingTool;

  /**
   * If we have been provided a serviceId in the url params,
   * we do not want to be able to initially navigate to the
   * service step.
   */
  const urlParams = new URLSearchParams(window.location.search);
  const prefilledOrganisationId = urlParams.get("organisationId");
  const isPrefilled = {
    resource: !!urlParams.get("resourceId"),
    service: !!urlParams.get("serviceId"),
    organisation: !!prefilledOrganisationId
  };
  const isSet = {
    resource: !!options.bookingData.resource,
    service: !!options.bookingData.service,
    organisation: !!options.bookingData.organisation && !!prefilledOrganisationId && options.bookingData.organisation._id.toString() === prefilledOrganisationId
  };
  const organisationsStepExists = forceOrganisationSelection || !(isPrefilled.organisation && isSet.organisation) && organisations.edges.length > 1;
  const servicesStepExists = !(isPrefilled.service && isSet.service) && (forceServiceSelection || services.edges.length !== 1);
  const serviceIsMultiTier = options.bookingData.service && options.bookingData.service.tiers && options.bookingData.service.tiers.length;
  if (options.bookingTool.organisationAvailabilityFlow) {
    return "locationAvailability";
  }
  if (organisationsStepExists) {
    return "organisations";
  }
  if (servicesStepExists) {
    return "services";
  }
  if (serviceIsMultiTier) {
    return "multiTier";
  }
  const resourceSelectionBeforeAvailability = options.bookingData.organisation?.resourceSelectionBeforeAvailability;
  if (resourceSelectionBeforeAvailability && options.bookingData.service?.resourceAllocationType === ResourceAllocationType.Any && (resourceSelectionMode !== ResourceSelectionMode.Disabled || isPrefilled.resource)) {
    return "resources";
  }
  return "availability";
};